import React, { useState, useEffect, useRef, useCallback } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";
import { GeoJSON, Popup,  Tooltip } from "react-leaflet";
import { createRoot } from "react-dom/client";
import { FaDrawPolygon, FaMapMarkerAlt, FaTrash, FaTimes } from "react-icons/fa";
import jsPDF from "jspdf";
import ExportPDFButton from './ExportPDFButton';
import "./Mapview.css";


export const handlePointSearch = async (
  lat,
  lng,
  map,
  polygonsRef,
  setSelectedLayers,
  setTitresData,
  setZonagesChecked,
  setZonagesDetails,
  setPolygonesExclus,
  deletedTitlesRef
) => {
  console.log("🔍 Recherche des titres autour de :", lat, lng);

  try {
    const response = await fetch(`https://api.qunciland.com/search?lat=${lat}&lng=${lng}`);

    if (!response.ok) {
      console.error(`❌ Erreur serveur : ${response.status} ${response.statusText}`);
      return;
    }

    const data = await response.json();

    if (!Array.isArray(data)) {
      console.error("❌ La réponse du serveur n'est pas un tableau :", data);
      return;
    }

    console.log(`${data.length} titre(s) trouvé(s) avant filtrage :`, data.map(t => ({id: t.gid, nom: t.titref})));

    // Vérifier si data est vide
    if (data.length === 0) {
      console.warn("⚠️ Aucun titre retourné par le serveur pour ce point. Vérifier : polygone, SRID ou coordonnées.");
    }

    console.log("📋 Liste des titres supprimés :", Array.from(deletedTitlesRef.current));

    const filteredData = data.filter(titre => {
      const isDeleted = deletedTitlesRef.current.has(titre.           gid);
      if (isDeleted) {
        console.log(`❌ Titre ${titre.gid} (${titre.titref}) filtré car supprimé`);
      }
      return !isDeleted;
    });

    if (filteredData.length === 0 && data.length > 0) {
      console.warn("⚠️ Tous les titres ont été filtrés comme supprimés.");
    }

    console.log(`Filtré à ${filteredData.length} titre(s) après exclusion des supprimés`);

    setTitresData(filteredData);

  } catch (error) {
    console.error("❌ Erreur lors de la recherche :", error);
  }
};


////////////////////////////////////////////////////////////////////////
function useWindowSize() {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
}
////////////////////////////////////////////////////////////////////////////////////






  const handleExportPDF = (titre, surfaceRestante) => {
  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.text("Fiche du Titre", 20, 20);

  doc.setFontSize(12);
  doc.text(`Titre : ${titre.titref || titre.graphic_de || titre.num || "Non défini"}`, 20, 40);
  if (titre.surf_adop) doc.text(`Surface : ${Number(titre.surf_adop).toFixed(2)} m²`, 20, 50);
  if (titre.pa_nom) doc.text(`PA : ${titre.pa_nom}`, 20, 60);
  doc.text(`Surface constructible : ${surfaceRestante.toFixed(2)} m²`, 20, 70);


  if (titre.zonages && titre.zonages.length > 0) {
    let y = 80;
    doc.text("Zonages intersectés :", 20, y);
    titre.zonages.forEach((z) => {
      y += 10;
      doc.text(`- ${z.nom || "Zonage"}`, 25, y);
    });
  }
  doc.save(`Rapport du Titre_${titre.gid}.pdf`);
};

/////////////////////////////////////////////////////////////////////////////////

export const handlePolygonSearch = async (polygonGeoJSON, setTitresData, setZonagesChecked, setZonagesDetails, setPolygonesExclus) => {
  console.log("🔍 Recherche des titres dans le polygone :", polygonGeoJSON);

  try {
    const geojsonStr = JSON.stringify(polygonGeoJSON.geometry);
    console.log("Polygone envoyé au serveur :", geojsonStr);

    const response = await fetch(`https://api.qunciland.com/api/titres-in-polygon`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: geojsonStr,
    });

    const data = await response.json();
    console.log("Titres avec zonages:", data);

    setTitresData(data);
    setZonagesChecked({});
    setZonagesDetails({});
    setPolygonesExclus({});
  } catch (error) {
    console.error("❌ Erreur lors de la recherche par polygone :", error);
  }
};

export function TitresDisplay({ 
  titresData, 
  selectedLayers, 
  setSelectedLayers, 
  zonagesChecked, 
  setZonagesChecked,
  zonagesDetails,
  setZonagesDetails,
  polygonesExclus,
  setPolygonesExclus,
  selectedZonage,
  setSelectedZonage,
  deleteMode,
  titlesToDelete, 
  setTitlesToDelete 
  
}) {

  const map = useMap();

  


  const [currentZoom, setCurrentZoom] = useState(map.getZoom());
  useEffect(() => {
  const handleZoom = () => {
    setCurrentZoom(map.getZoom());
  };

  map.on("zoomend", handleZoom);

  return () => {
    map.off("zoomend", handleZoom);
  };
}, [map]);

let surfaceMin;



if (currentZoom >= 20) {
  surfaceMin = 0;        // 🔥 tout afficher
}
else if (currentZoom >= 19) {
  surfaceMin = 50;       // très petites surfaces
}
else if (currentZoom >= 18) {
  surfaceMin = 150;      // petites
}
else if (currentZoom >= 17) {
  surfaceMin = 400;      // moyennes
}
else if (currentZoom >= 16) {
  surfaceMin = 1000;     // grandes
}
else if (currentZoom >= 15) {
  surfaceMin = 3000;     // très grandes
}
else {
  surfaceMin = Infinity; // aucun label
}

const titresFiltres = titresData
  .filter(t => t.surf_adop && Number(t.surf_adop) >= surfaceMin);



  

const handlePolygonClickInDeleteMode = useCallback((e, titreGid) => {

  e.originalEvent.stopPropagation();
  e.originalEvent.preventDefault();
  
 
  L.DomEvent.stop(e);
  
  const isCtrlPressed = e.originalEvent.ctrlKey || e.originalEvent.metaKey;
  
  if (isCtrlPressed) {
    setTitlesToDelete(prev => 
      prev.includes(titreGid) 
        ? prev.filter(id => id !== titreGid)
        : [...prev, titreGid]
    );
  } else {
    setTitlesToDelete(prev => 
      prev.includes(titreGid) 
        ? prev.filter(id => id !== titreGid)
        : [titreGid]
    );
  }
}, [setTitlesToDelete]);



const handleZonageToggle = (titreGid, zonage) => {
  const zonageKey = `${titreGid}-${zonage.zonage_gid}`;
  
  // Utiliser la valeur actuelle AVANT le changement
  const currentValue = zonagesChecked[zonageKey];
  
  // Inverser la valeur
  const newValue = !currentValue;
  
  setZonagesChecked(prev => ({
    ...prev,
    [zonageKey]: newValue
  }));
  
  // Si on décoche un zonage (passant de true à false), réinitialiser ses polygones exclus
  if (currentValue === true) {
    setPolygonesExclus(prev => {
      const newExclus = { ...prev };
      Object.keys(newExclus).forEach(key => {
        if (key.startsWith(`${titreGid}-${zonage.zonage_gid}-`)) {
          delete newExclus[key];
        }
      });
      return newExclus;
    });
  }
};

  const chargerDetailsZonage = async (titreGid, zonage) => {
    try {
      const res = await fetch(`https://api.qunciland.com/api/titres/${titreGid}/zonages/${zonage.zonage_gid}`);
      const details = await res.json();
      
      setZonagesDetails(prev => ({
        ...prev,
        [`${titreGid}-${zonage.zonage_gid}`]: details
      }));

    } catch (err) {
      console.error("Erreur chargement détails zonage:", err);
    }
  };

  const handleEyeClick = (titreGid, zonage) => {
    if (!zonage || !zonage.zonage_gid) return;

    setSelectedZonage({ ...zonage, titreGid });

    const detailKey = `${titreGid}-${zonage.zonage_gid}`;
    if (!zonagesDetails[detailKey]) {
      chargerDetailsZonage(titreGid, zonage);
    }
  };

  const handleExcludePolygon = useCallback((titreGid, zonageGid, polygoneIndex, surface) => {
    const polygoneKey = `${titreGid}-${zonageGid}-${polygoneIndex}`;
    
    setPolygonesExclus(prev => ({
      ...prev,
      [polygoneKey]: {
        excluded: true,
        surface: surface
      }
    }));
  }, []);

  function ZonageCheckbox({ titreGid, zonage, isChecked, onToggle, onEyeClick }) {
    const handleCheckboxChange = (e) => {
      e.stopPropagation();
      onToggle(titreGid, zonage);
    };

    const handleEyeClick = (e) => {
      e.stopPropagation();
      onEyeClick(titreGid, zonage);
    };

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "4px",
          padding: "2px 0",
          borderBottom: "1px solid #eee"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <strong>{zonage.type_zonage}</strong>
          <span>{Number(zonage.surface_intersection_totale_m2).toFixed(2)} m²</span>
          <span>{Number(zonage.pourcentage_intersection).toFixed(2)}%</span>
        </div>

        <div 
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          onClick={(e) => e.stopPropagation()}
        >
          <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            Constructible
          </label>

          <button
            onClick={handleEyeClick}
            style={{
              cursor: "pointer",
              border: "none",
              background: "transparent",
              fontSize: "16px"
            }}
            title="Voir ce zonage sur la carte"
          >
            👁
          </button>
        </div>
      </div>
    );
  }



   return (
    <>
      {titresData.map((titre) => {
        const surfaceRestante = titre.surf_adop -
          (titre.zonages?.reduce((sum, z) => {
            const zonageKey = `${titre.gid}-${z.zonage_gid}`;
            const isConstructible = zonagesChecked[zonageKey];
            
            let surfaceNonConstructible = isConstructible ? 0 : Number(z.surface_intersection_totale_m2 || 0);
            
            if (zonagesDetails[zonageKey]?.polygones_individualises) {
              zonagesDetails[zonageKey].polygones_individualises.forEach((polygone, idx) => {
                const polygoneKey = `${titre.gid}-${z.zonage_gid}-${idx}`;
                if (polygonesExclus[polygoneKey]?.excluded) {
                  surfaceNonConstructible += polygonesExclus[polygoneKey].surface;
                }
              });
            }

            return sum + surfaceNonConstructible;
          }, 0) || 0);


          const titreLabel =
              titre.titref || titre.graphic_de || titre.num || "Non défini";

            const surfaceLabel = titre.surf_adop
              ? `${Number(titre.surf_adop).toFixed(2)} m²`
              : "Surface inconnue";

            const fullLabel = `${titreLabel} - ${surfaceLabel}`;


        return (
         <GeoJSON
  key={titre.gid}
  data={JSON.parse(titre.geom_geojson)}
  style={{
    color: titlesToDelete.includes(titre.gid) ? "#dc3545" : "orange",
    weight: titlesToDelete.includes(titre.gid) ? 4 : 2,
    fillOpacity: titlesToDelete.includes(titre.gid) ? 0.6 : 0.3,
    fillColor: titlesToDelete.includes(titre.gid) ? "#dc3545" : "orange",
  }}
  eventHandlers={{
  click: (e) => {

    if (deleteMode) {
      e.originalEvent.stopPropagation();
      e.target.closePopup(); 
    }

    handlePolygonClickInDeleteMode(e, titre.gid);
  },
  mouseover: (e) => {
    e.target.setStyle({ weight: 4, fillOpacity: 0.6 });
  },
  mouseout: (e) => {
    e.target.setStyle({
      weight: titlesToDelete.includes(titre.gid) ? 4 : 2,
      fillOpacity: titlesToDelete.includes(titre.gid) ? 0.6 : 0.3,
      color: titlesToDelete.includes(titre.gid) ? "#dc3545" : "orange",
      fillColor: titlesToDelete.includes(titre.gid) ? "#dc3545" : "orange",
    });
  },
}}

>

  {!deleteMode && (
    <Popup>
      <div className="popup-modern">
        <div className="popup-header">
          <h3>{titre.titref || titre.graphic_de || titre.num || "Non défini"}</h3>
        </div>

        <div className="popup-section">
          {titre.surf_adop && (
            <p>
              <strong>Surface :</strong> {Number(titre.surf_adop).toFixed(2)} m²
            </p>
          )}
          {titre.pa_nom ? (
            <p><strong>PA :</strong> {titre.pa_nom}</p>
          ) : (
            <p className="popup-error">❌ Aucun PA trouvé</p>
          )}
        </div>

        <div className="popup-section">
          <h4>Zonages intersectés</h4>
          {titre.zonages && titre.zonages.length > 0 ? (
            <div className="popup-zonages">
              {titre.zonages.map((z) => {
                const zonageKey = `${titre.gid}-${z.zonage_gid}`;
                const isChecked = zonagesChecked[zonageKey];
                return (
                  <ZonageCheckbox
                    key={zonageKey}
                    titreGid={titre.gid}
                    zonage={z}
                    isChecked={isChecked}
                    onToggle={handleZonageToggle}
                    onEyeClick={handleEyeClick}
                  />
                );
              })}
            </div>
          ) : (
            <p className="popup-error">❌ Aucun zonage trouvé</p>
          )}
        </div>

        <div className="popup-highlight">
          <strong>Surface constructible :</strong> {surfaceRestante.toFixed(2)} m²
        </div>

        <ExportPDFButton 
        titre={titre} 
        surfaceRestante={surfaceRestante}
        zonagesChecked={zonagesChecked} 
      />
      </div>
    </Popup>
    
  )}
  {currentZoom >= 16 &&
 titresFiltres.some(t => t.gid === titre.gid) && (

  <Tooltip
    permanent
    direction="center"
    className="titre-label"
    opacity={1}
  >
    <div className={`titre-text zoom-${currentZoom}`}>
      <strong>{titreLabel}</strong>
      <br />
      {surfaceLabel}
    </div>
  </Tooltip>

)}

</GeoJSON>

        );
      })}
      
      {selectedZonage &&
        zonagesDetails[`${selectedZonage.titreGid}-${selectedZonage.zonage_gid}`] &&
        Array.isArray(zonagesDetails[`${selectedZonage.titreGid}-${selectedZonage.zonage_gid}`].polygones_individualises) &&
        zonagesDetails[`${selectedZonage.titreGid}-${selectedZonage.zonage_gid}`].polygones_individualises.map((polygone, idx) => (
          <GeoJSON
            key={`${selectedZonage.zonage_gid || 'polygon'}-${idx}`}
            data={JSON.parse(polygone.geom_geojson)}
            style={{
              color: polygonesExclus[`${selectedZonage.titreGid}-${selectedZonage.zonage_gid}-${idx}`]?.excluded ? "#da3838ff" : "#0066cc",
              weight: 2,
              fillOpacity: 0.3,
              fillColor: polygonesExclus[`${selectedZonage.titreGid}-${selectedZonage.zonage_gid}-${idx}`]?.excluded ? "#da3838ff" : "#0066cc",
            }}
          >
            <Popup>
              <div style={{ padding: "8px", minWidth: "200px" }}>
                <div style={{ fontSize: "14px" }}>
                  <div><strong>Zonage:</strong> {selectedZonage.type_zonage}</div>
                  <div style={{ borderBottom: "1px solid #eee", margin: "4px 0" }}></div>
                  <div><strong>Surface:</strong> {Number(polygone.surface_intersection_individuelle_m2).toFixed(2)} m²</div>

                  <div style={{ marginTop: "8px", textAlign: "center" }}>
                    <button
                      style={{
                        padding: "8px 16px",
                        background: "linear-gradient(135deg, #7dbae2ff, #2980b9)",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = "linear-gradient(135deg,#2980b9, #2573a7ff)";
                        e.target.style.transform = "scale(1.05)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = "linear-gradient(135deg, #9cd4f9ff, #2573a7ff)";
                        e.target.style.transform = "scale(1)";
                      }}
                      onClick={() => {
                        handleExcludePolygon(
                          selectedZonage.titreGid,
                          selectedZonage.zonage_gid,
                          idx,
                          Number(polygone.surface_intersection_individuelle_m2)
                        );
                      }}
                    >
                      Exclure cette surface
                    </button>
                  </div>
                </div>
              </div>
            </Popup>
          </GeoJSON>
        ))}
    </>
  );
}

export default function DrawPolygonControl({ titresFromPolygonControl,
  setTitresFromPolygonControl,
  setDeleteModeGlobal,
  setTitlesToDeleteGlobal,
  deleteModeGlobal,
  titlesToDeleteGlobal,
  deletedTitlesRef,
  
  handleDeleteTitres }) {
  const map = useMap();
  const controlRef = useRef(null); 
  const polygonsRef = useRef([]);
  const [selectedLayers, setSelectedLayers] = useState([]);
  const [titresData, setTitresData] = useState([]);
  const [zonagesChecked, setZonagesChecked] = useState({});
  const [zonagesDetails, setZonagesDetails] = useState({});
  const [polygonesExclus, setPolygonesExclus] = useState({});
  const [selectedZonage, setSelectedZonage] = useState(null);
  
  // États pour la suppression
  const [deleteMode, setDeleteMode] = useState(false);
  const [titlesToDelete, setTitlesToDelete] = useState([]);
  const [drawnPolygon, setDrawnPolygon] = useState(null);
  // 🆕 État pour activer le mode Marker
  const [markerMode, setMarkerMode] = useState(false);
  const markerRef = useRef(null); // référence au marker
  const { width, height } = useWindowSize();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [currentZoom, setCurrentZoom] = useState(map.getZoom());
  const MIN_ZOOM_LABEL = 15;

useEffect(() => {
  const handleZoom = () => {
    setCurrentZoom(map.getZoom());
  };

  map.on("zoomend", handleZoom);

  return () => {
    map.off("zoomend", handleZoom);
  };
}, [map]);

  

useEffect(() => {
  const mediaQuery = window.matchMedia("(max-width: 599px)");
  const handler = (e) => setIsMobile(e.matches);
  
  mediaQuery.addEventListener("change", handler);

  // Au montage
  setIsMobile(mediaQuery.matches);

  return () => mediaQuery.removeEventListener("change", handler);
}, []);




// Dans DrawPolygonControl, ajoutez cette fonction
const resetAllTitles = () => {
  setTitresData([]);
  setSelectedLayers([]);
  setZonagesChecked({});
  setZonagesDetails({});
  setPolygonesExclus({});
  setSelectedZonage(null);
  deletedTitlesRef.current.clear();
  setTitlesToDelete([]);
  setDeleteMode(false);
};

    // 🆕 UTILISER LES ÉTATS GLOBAUX SI DISPONIBLES
  const actualDeleteMode = deleteModeGlobal !== undefined ? deleteModeGlobal : deleteMode;
  const actualTitlesToDelete = titlesToDeleteGlobal !== undefined ? titlesToDeleteGlobal : titlesToDelete;

  const confirmDelete = () => {
  if (titlesToDelete.length === 0) {
    alert("Veuillez sélectionner au moins un titre à supprimer");
    return;
  }

  // Ajouter les IDs à la liste des titres supprimés
  titlesToDelete.forEach(id => deletedTitlesRef.current.add(id));

  const remainingTitles = titresData.filter(titre => 
    !titlesToDelete.includes(titre.gid)
  );

  setTitresData(remainingTitles);
  setSelectedLayers(prev => prev.filter(id => !titlesToDelete.includes(id)));



  setZonagesChecked(prev => {
    const newChecked = { ...prev };
    titlesToDelete.forEach(titreGid => {
      Object.keys(newChecked).forEach(key => {
        if (key.startsWith(`${titreGid}-`)) {
          delete newChecked[key];
        }
      });
    });
    return newChecked;
  });

  setZonagesDetails(prev => {
    const newDetails = { ...prev };
    titlesToDelete.forEach(titreGid => {
      Object.keys(newDetails).forEach(key => {
        if (key.startsWith(`${titreGid}-`)) {
          delete newDetails[key];
        }
      });
    });
    return newDetails;
  });

  setPolygonesExclus(prev => {
    const newExclus = { ...prev };
    titlesToDelete.forEach(titreGid => {
      Object.keys(newExclus).forEach(key => {
        if (key.startsWith(`${titreGid}-`)) {
          delete newExclus[key];
        }
      });
    });
    return newExclus;
  });

  if (selectedZonage && titlesToDelete.includes(selectedZonage.titreGid)) {
    setSelectedZonage(null);
  }

  setDeleteMode(false);
  setTitlesToDelete([]);
};

   // 🆕 SYNCHRONISATION AVEC L'ÉTAT GLOBAL
  useEffect(() => {
    if (setTitresFromPolygonControl) {
      setTitresFromPolygonControl(titresData);
    }
  }, [titresData, setTitresFromPolygonControl]);

  // 🆕 SYNCHRONISATION DU MODE SUPPRESSION AVEC LE PARENT
  useEffect(() => {
    if (setDeleteModeGlobal) {
      setDeleteModeGlobal(deleteMode);
    }
  }, [deleteMode, setDeleteModeGlobal]);

  // 🆕 SYNCHRONISATION DES TITRES À SUPPRIMER AVEC LE PARENT
  useEffect(() => {
    if (setTitlesToDeleteGlobal) {
      setTitlesToDeleteGlobal(titlesToDelete);
    }
  }, [titlesToDelete, setTitlesToDeleteGlobal]);

useEffect(() => {
  if (!map || !markerMode) return;

const handleMapClick = async (e) => {
  const { lat, lng } = e.latlng;


  if (markerRef.current) {
    map.removeLayer(markerRef.current);
    markerRef.current = null;
  }


  const marker = L.marker([lat, lng]).addTo(map);
  markerRef.current = marker;


  await handlePointSearch(
    lat,
    lng,
    map,
    polygonsRef,
    setSelectedLayers,
    setTitresData,
    setZonagesChecked,
    setZonagesDetails,
    setPolygonesExclus,
    deletedTitlesRef 
  );


  if (markerRef.current) {
    map.removeLayer(markerRef.current);
    markerRef.current = null;
  }

  setMarkerMode(false);
};

  const handleEscPress = (e) => {
    if (e.key === "Escape") {
      setMarkerMode(false); 
    }
  };

  map.on("click", handleMapClick);
  window.addEventListener("keydown", handleEscPress);

  return () => {
    map.off("click", handleMapClick);
    window.removeEventListener("keydown", handleEscPress);
  };
}, [map, markerMode]);


  useEffect(() => {
    if (!drawnPolygon) return;
    
    const geojsonStr = JSON.stringify(drawnPolygon.geometry);
    console.log("Polygone envoyé au serveur :", geojsonStr);

    fetch(`https://api.qunciland.com/api/titres-in-polygon`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: geojsonStr,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Titres avec zonages:", data);
        setTitresData(data);
        

        setZonagesChecked({});
        setZonagesDetails({});
        setPolygonesExclus({});
        setSelectedZonage(null);
      })
      .catch((err) => console.error(err));
  }, [drawnPolygon]);

  useEffect(() => {
    if (!map) return;
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);

    const container = L.DomUtil.create("div", "leaflet-control leaflet-bar");
    container.style.cssText = `
      background: rgba(255, 255, 255, 0.9);
      padding: 8px;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;
    `;


    const btnStyle = `
      cursor: pointer;
      background: white;
      border-radius: 8px;
      width: 34px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 5px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.2);
      transition: 0.2s;
    `;


    const polygonBtn = L.DomUtil.create("div", "", container);
    polygonBtn.style.cssText = btnStyle;
    polygonBtn.title = "Dessiner un polygone";
    createRoot(polygonBtn).render(<FaDrawPolygon color="#2980b9" size={18} />);
    polygonBtn.onmouseover = () => {
      polygonBtn.style.transform = "scale(1.1)";
      polygonBtn.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
    };
    polygonBtn.onmouseout = () => {
      polygonBtn.style.transform = "scale(1)";
      polygonBtn.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
    };
    
    L.DomEvent.on(polygonBtn, "click", (e) => {
      L.DomEvent.stopPropagation(e);
      const polygonDrawer = new L.Draw.Polygon(map, { allowIntersection: false });
      polygonDrawer.enable();

      map.once(L.Draw.Event.CREATED, (event) => {
        const layer = event.layer;
        drawnItems.clearLayers();
        drawnItems.addLayer(layer);
        setDrawnPolygon(layer.toGeoJSON());
      });
    });

   const markerBtn = L.DomUtil.create("div", "", container);
    markerBtn.style.cssText = btnStyle;
    markerBtn.title = "Placer un point";
    createRoot(markerBtn).render(<FaMapMarkerAlt color="#2980b9" size={18} />);
    markerBtn.onmouseover = () => {
      markerBtn.style.transform = "scale(1.1)";
      markerBtn.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
    };
    markerBtn.onmouseout = () => {
      markerBtn.style.transform = "scale(1)";
      markerBtn.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
    };

    L.DomEvent.on(markerBtn, "click", (e) => {
      L.DomEvent.stopPropagation(e);
      setMarkerMode(true); 
    });

    const btnClear = L.DomUtil.create("div", "", container);
    btnClear.style.cssText = btnStyle;
    btnClear.title = "Supprimer des titres";

    createRoot(btnClear).render(<FaTrash color="#2980b9" size={16} />);

    btnClear.onmouseover = () => {
      btnClear.style.transform = "scale(1.1)";
      btnClear.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
    };
    btnClear.onmouseout = () => {
      btnClear.style.transform = "scale(1)";
      btnClear.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
    };

    L.DomEvent.on(btnClear, "click", (e) => {
  L.DomEvent.stopPropagation(e);

  if (setDeleteModeGlobal) {
    setDeleteModeGlobal(true);
  }

});

    if (!controlRef.current) {
      const ControlClass = L.Control.extend({
        options: { position: "topright" },
        onAdd: () => container,
      });
      controlRef.current = new ControlClass();
      map.addControl(controlRef.current);
    }

    return () => {
      map.removeLayer(drawnItems);
      if (controlRef.current) {
        map.removeControl(controlRef.current);
        controlRef.current = null;
      }
    };
  }, [map, setDrawnPolygon, titresData, titresFromPolygonControl, setDeleteModeGlobal]);

  const toggleTitleSelection = (titreGid) => {
    setTitlesToDelete(prev => 
      prev.includes(titreGid) 
        ? prev.filter(id => id !== titreGid)
        : [...prev, titreGid]
    );
  };


  const cancelDelete = () => {
  setDeleteMode(false);
};


  return (
    
    <>
   
    {deleteMode && (
  <div
    style={{
      position: "fixed",
      top: isMobile ? "50px" : "80px",
      left: "50%",
      transform: "translateX(-50%)",
      background: "white",
      padding: isMobile ? "8px" : "20px",
      borderRadius: isMobile ? "6px" : "10px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
      zIndex: 10000,
      minWidth: isMobile ? "75%" : "600px",
      maxWidth: isMobile ? "90%" : "600px",
      maxHeight: isMobile ? "50vh" : "450px",
      overflowY: "auto",
      border: "2px solid #2980b9",
      transition: "all 0.3s ease",
      boxSizing: "border-box",
    }}
  >

    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "15px",
      borderBottom: "2px solid #2980b9",
      paddingBottom: "10px"
    }}>
      <h3 style={{ margin: 0, color: "#2980b9" }}>
        Sélectionnez les titres à supprimer
      </h3>
      <button 
        onClick={cancelDelete}
        style={{
          background: "none",
          border: "none",
          fontSize: "18px",
          cursor: "pointer",
          color: "#666",
          padding: "5px"
        }}
        title="Fermer"
      >
        <FaTimes />
      </button>
    </div>

  

    <div style={{ marginBottom: "15px" }}>
      {titresData.map(titre => (
        <div 
          key={titre.gid}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px",
            margin: "5px 0",
            background: titlesToDelete.includes(titre.gid) ? "#e3f2fd" : "white",
            border: `2px solid ${titlesToDelete.includes(titre.gid) ? "#2980b9" : "#ddd"}`,
            borderRadius: "5px",
            cursor: "pointer",
            transition: "all 0.2s",
            position: "relative"
          }}
          onClick={(e) => {
            if (e.ctrlKey || e.metaKey) {
              // Sélection/déselection multiple avec Ctrl
              toggleTitleSelection(titre.gid);
            } else {
              // Sélection simple (remplace la sélection actuelle)
              if (titlesToDelete.includes(titre.gid)) {
                // Si déjà sélectionné, on le désélectionne
                setTitlesToDelete(prev => prev.filter(id => id !== titre.gid));
              } else {
                // Sinon, on sélectionne seulement ce titre
                setTitlesToDelete([titre.gid]);
              }
            }
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = titlesToDelete.includes(titre.gid) 
              ? "#bbdefb" 
              : "#f5f5f5";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = titlesToDelete.includes(titre.gid) 
              ? "#e3f2fd" 
              : "white";
          }}
        >
          <input
            type="checkbox"
            checked={titlesToDelete.includes(titre.gid)}
            onChange={() => toggleTitleSelection(titre.gid)}
            style={{ marginRight: "10px" }}
            onClick={(e) => e.stopPropagation()} 
          />
          <div style={{ flex: 1 }}>
            <strong>{titre.titref || titre.graphic_de || titre.num || "Titre sans nom"}</strong>
            {titre.surf_adop && (
              <div style={{ fontSize: "12px", color: "#666" }}>
                Surface: {Number(titre.surf_adop).toFixed(2)} m²
              </div>
            )}
          </div>
          {titlesToDelete.includes(titre.gid) && (
            <div style={{
              position: "absolute",
              top: "5px",
              right: "5px",
              width: "8px",
              height: "8px",
              backgroundColor: "#2980b9",
              borderRadius: "50%"
            }} />
          )}
        </div>
      ))}
    </div>

    <div style={{
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
      marginBottom: "15px"
    }}>
      <button
        onClick={() => {

          setTitlesToDelete(titresData.map(titre => titre.gid));
        }}
        style={{
          padding: "6px 12px",
          background: "#28a745",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "12px",
          fontWeight: "bold"
        }}
      >
        Tout sélectionner
      </button>
      <button
        onClick={() => {
          setTitlesToDelete([]);
        }}
        style={{
          padding: "6px 12px",
          background: "#6c757d",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "12px",
          fontWeight: "bold"
        }}
      >
        Tout désélectionner
      </button>
    </div>

    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "10px",
      marginTop: "15px",
      paddingTop: "15px",
      borderTop: "1px solid #eee"
    }}>
      <div style={{
        fontSize: "14px",
        color: "#666",
        fontWeight: "bold"
      }}>
        {titlesToDelete.length} titre(s) sélectionné(s)
      </div>
      
      <div style={{
        display: "flex",
        gap: "10px"
      }}>
        <button
          onClick={cancelDelete}
          style={{
            padding: "8px 16px",
            background: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "bold"
          }}
        >
          Annuler
        </button>
        <button
          onClick={confirmDelete}
          disabled={titlesToDelete.length === 0}
          style={{
            padding: "8px 16px",
            background: titlesToDelete.length === 0 ? "#ccc" : "#dc3545",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: titlesToDelete.length === 0 ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            fontWeight: "bold"
          }}
        >
          <FaTrash size={12} />
          Supprimer ({titlesToDelete.length})
        </button>
      </div>
    </div>
  </div>
)}
    </>
  );
}